import React from "react";
import Company_Logo from "../../asesst/Company_Logo.svg";
import Login_Frame from "../../asesst/Login_Frame.svg";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router";
import { FORGOT_PASSWORD, LOGIN, RESET_LINK } from "../utils/RouteConstant";
import New_Image from "../../asesst/New_Header.png"

const AuthLayout = ({ title, description, form, footerText }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const showBackButton = [RESET_LINK, FORGOT_PASSWORD].includes(
    location.pathname
  );
  const showFooterButton = [RESET_LINK].includes(location.pathname);

  return (
    <div className="flex flex-col lg:flex-row min-h-screen">
      <div className="fixed top-0 left-0 mt-4 ml-4 md:ml-8 lg:ml-0 md:p-8 lg:p-12 z-10">
        <img
          src={Company_Logo}
          alt="Óvalo Quality Group"
          className="h-12 w-12 sm:h-16 sm:w-16 md:h-20 md:w-20 lg:h-36 lg:w-36"
        />
      </div>
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 md:p-8 lg:p-8 min-h-screen">
        <div className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl">
          {showBackButton && (
            <div
              className="flex mb-4 md:mb-8 mt-16 sm:mt-20 md:mt-24 lg:mt-0 items-center cursor-pointer"
              onClick={() => navigate(LOGIN)}
            >
              <FaArrowLeftLong className="mr-2 md:mr-4 font-poppins text-sm md:text-base text-[#5F6368]" />
              <span className="text-[#5F6368] font-poppins text-sm md:text-base">
                Back to Login
              </span>
            </div>
          )}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 md:mb-6 text-[#313131]">
            {title}
          </h2>
          <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-8">
            {description}
          </p>
          {form}
          {showFooterButton && (
            <p className="text-center text-sm md:text-base text-gray-500 mt-4">
              {footerText}
            </p>
          )}
        </div>
        <div className="absolute inset-x-0 bottom-4">
          <p className="text-xs md:text-sm lg:text-base text-center text-gray-500 mt-8 lg:mt-16">
            © Óvalo Quality Group, Inc.
          </p>
        </div>
      </div>
      <div className="w-full lg:w-1/2 flex justify-center items-center p-4 sm:p-8 md:p-16 min-h-screen">
        <img
          src={New_Image}
          alt="Quality Control"
          className="w-full h-full max-w-sm sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl object-cover rounded-3xl"
        />
      </div>
    </div>
  );
};

export default AuthLayout;
